import React from "react";
import { useForm } from "@mantine/form";
import { TextInput } from "@mantine/core";
import AuthWindow from "@components/Auth/AuthWindow";
import { useRouter } from "next/router";
import { useLoginMutation } from "@lib/store/slices/user";
import getFormElementError from "@lib/utils/form/getFormElementError";
import Link from "next/link";
import { trackEvent } from "@components/Various/Analytics/gtag";
import BrandButton from "@components/Various/BrandButton";

function Login() {
  const form = useForm({
    initialValues: {
      email: "",
      password: "",
    },

    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
      password: (value) => (value.length < 1 ? "Please enter password" : null),
    },
  });

  const [loginError, setLoginError] = React.useState<string | undefined>();
  const [login, { isLoading, error }] = useLoginMutation();
  const router = useRouter();

  const onLogin = (values: { email: string; password: string }) => {
    setLoginError(undefined);

    login(values).then((data) => {
      if (!("error" in data)) {
        router.push((router.query.returnUrl as string) ?? "/account/jobs");

        trackEvent({
          action: "login",
          category: "account",
          label: "login",
        });
      } else {
        const message = (data.error as any).data.message;
        setLoginError(message);
        trackEvent({
          action: "login_failed",
          category: "account",
          label: message,
        });
      }
    });
  };

  return (
    <AuthWindow
      action="Anmelden"
      alternativeActionPreamble="Noch keinen Account?"
      alternativeActionLink="/account/auth/register"
      alternativeActionText="Registrieren"
      isLoading={isLoading}
      error={loginError}
    >
      <form onSubmit={form.onSubmit(onLogin)}>
        <TextInput
          required
          label="Email"
          placeholder="musterperson@email.com"
          className="mb-6"
          error={getFormElementError("email", error)}
          {...form.getInputProps("email")}
        />
        <TextInput
          required
          type="password"
          label="Passwort"
          placeholder="*******"
          error={getFormElementError("password", error)}
          {...form.getInputProps("password")}
        />

        <div className="text-right text-sm text-slate-500 underline my-3">
          <Link href="/account/auth/forgot-password">Passwort vergessen?</Link>
        </div>
        <BrandButton type="submit" className="py-3">
          Anmelden
        </BrandButton>
      </form>
    </AuthWindow>
  );
}

export { getStaticProps } from "@lib/utils/translationsStaticProps";
export default Login;
